import { createContext, use, useContext, useState } from "react";
import api from "../common/api/api";
import { toast } from "react-toastify";
import PropTypes from "prop-types";

export const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [loading, setLoading] = useState(false);
    const [settingsData, setSettingsData] = useState([]);


    const getGlobalSettings = async (request) => {
        try {
            const response = await api.globalSetting.getAllGlobalSettings(request);
            if (response?.success ) {
                setSettingsData([response.data]);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    const updateGlobalSetting = async (request) => {
        setLoading(true);
        try {
            const response = await api.globalSetting.updateGlobalSettings(request);
            if (response?.success) {
                setLoading(false);
                toast.success(response?.message);
                getGlobalSettings();
            }
        } catch (error) {
            setLoading(false);
            toast.error(error?.message || "Something went wrong!");
        } finally {
            setLoading(false);
        }
    };

    const contextValue = {
        loading,
        getGlobalSettings,
        settingsData,
        updateGlobalSetting,
    }

    return (
        <SettingsContext.Provider value={contextValue}>{children}</SettingsContext.Provider>
    )
};

SettingsProvider.propTypes = {
    children: PropTypes.node
}

export const useSettings = () => useContext(SettingsContext);